import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function ProblemAgitation() {
  return <section className="w-full bg-[#FAF8FF] py-16 md:py-24 px-6" data-id="element-299">
      <div className="max-w-3xl mx-auto" data-id="element-300">
        <FadeIn data-id="element-301">
          <h2 className="text-3xl md:text-4xl font-serif text-night-900 text-center mb-10 md:mb-12" data-id="element-302">
            ¿Reconoces esto?
          </h2>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-303">
          <p className="text-lg md:text-xl text-slate-700 mb-6 md:mb-8 leading-relaxed" data-id="element-304">
            Son las 11pm. Tu cuerpo está agotado. Pero tu mente ya arrancó sola:
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-305">
          <div className="bg-white p-6 md:p-8 rounded-2xl shadow-sm border border-purple-100 border-l-4 border-l-purple-400 mb-8 relative" data-id="element-306">
            <div className="absolute top-0 left-6 md:left-8 -translate-y-1/2 text-5xl md:text-6xl text-purple-200 font-serif" data-id="element-307">
              "
            </div>
            <ul className="space-y-3 md:space-y-4 text-base md:text-xl font-serif italic text-slate-600 relative z-10" data-id="element-308">
              <li data-id="element-309">"Mañana tengo que..."</li>
              <li data-id="element-310">"¿Y si pasa...?"</li>
              <li data-id="element-311">"Debí haberle dicho..."</li>
              <li data-id="element-312">
                "Ya son las 12... si me duermo ahora me quedan 6 horas..."
              </li>
            </ul>
          </div>
        </FadeIn>

        <div className="space-y-5 md:space-y-6 text-lg md:text-xl text-slate-700 leading-relaxed" data-id="element-313">
          <FadeIn delay={0.3} data-id="element-314">
            <p data-id="element-315">
              Y cuanto más intentas "relajarte"... más despierta te sientes.
            </p>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-316">
            <p data-id="element-317">
              Te das vueltas. Revisas el teléfono. Lo dejas. Lo vuelves a
              agarrar.
            </p>
          </FadeIn>

          <FadeIn delay={0.5} data-id="element-318">
            <p data-id="element-319">
              Y cuando por fin te duermes... te despiertas a las 3am con el
              corazón acelerado y la mente lista para continuar donde lo dejó.
            </p>
          </FadeIn>

          <FadeIn delay={0.6} data-id="element-320">
            <p data-id="element-321">
              Al día siguiente te levantas emocionalmente frágil, con poca
              paciencia, y sintiendo que tu cuerpo nunca descansó de verdad.
            </p>
          </FadeIn>
        </div>

        <FadeIn delay={0.7} data-id="element-322">
          <div className="mt-12 md:mt-16 p-6 md:p-8 bg-purple-50 rounded-2xl text-center" data-id="element-323">
            <p className="text-lg md:text-2xl font-serif font-medium text-night-900 leading-relaxed" data-id="element-324">
              Esto no es insomnio. Y no es que estés rota. Es que nadie te
              enseñó cómo hacer la transición real del modo alerta al modo
              descanso.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}